// Copy of giftVirtualRegister

module.controller('redeemVirtualCtrl', ['$scope', '$state','baseURI', '$http', 'Transform', '$stateParams', '$window', '$timeout', 'giftAuthService', 'trustPilotService', 'brandService', '$sce', function($scope, $state,baseURI, $http, Transform, $stateParams, $window, $timeout, giftAuthService, trustPilotService, brandService, $sce){
  var vm = this;
  var giftVirtualRegisterUrl = baseURI + 'gift-card/collect/virtual';
  var companyPhoneNumber = '2102494100';

  /**
   * The user's password
   * @type {string} - passwordInputType
   */
  $scope.passwordInputType = 'password';

  /**
   * Condition that displays the showValidateEmail modal window
   * @type {boolean} - showValidateEmail
   */
  $scope.showValidateEmail = false;
  $scope.showUpdatedEmail = false;
  $scope.loadingEmailVerification = false;
  $scope.attemptToChangeEmail = false;
  $scope.attemptToRedeemCode = false;

  /**
   * The formatted version of the phone number (ex: 111-222-3333)
   * @type {string} - formattedPhone
   */
  var formattedPhone;

  //
  // Get user parameters from the URL to pre-populate the form with that data
  //
  if (!$scope.formData.firstName) {
    $scope.formData.firstName = $stateParams.fname;       // First name
  }
  if (!$scope.formData.lastName) {
    $scope.formData.lastName = $stateParams.lname;        // Last name
  }
  if(!$scope.formData.RedeemCode) {
    $scope.formData.RedeemCode = $stateParams.RedeemCode; // Redeem code
  }
  if(!$scope.formData.email) {
    $scope.formData.email = $stateParams.email;           // Email
  }
  if(!$scope.formData.phone) {
    $scope.formData.phone = $stateParams.phone;           // Phone
  }
  // Set default delivery method to email
  if(!$scope.formData.deliveryMethod) {
    $scope.formData.deliveryMethod = "email";
  }

  // If there a deliveryMethod parameter, assign it to the formData being passed and act accordingly
  if($stateParams.deliveryMethod != null) {
    $scope.formData.deliveryMethod = $stateParams.deliveryMethod;
  }

  /**
   * @type {string[]|*} - readonlyFields
   */
  var readonlyFields;

  // Search for unique brand redeem-code fields
  try {
    $scope.isPhoneReadonly = $scope.brand.redeemCodeFields.readonly.phone;
    $scope.isEmailReadonly = $scope.brand.redeemCodeFields.readonly.email;
  }
  // If they don't exist, load the default redeem-code fields
  catch (e) {

    readonlyFields = brandService.getRedeemCodeFields();

    $scope.isPhoneReadonly = readonlyFields.phone;
    $scope.isEmailReadonly = readonlyFields.email;
  }

  // set parent view form class
  $scope.parent.formType = 'floatingForm-form';

  /**
   * @function goToSuccessPage
   * @param message
   */
  var goToSuccessPage = function(message) {
    $state.go('root.redeem.success', {
      successMessage: message,
      username: $scope.formData.email,
    });
  };

  /**
   * @function attemptSubmission
   * @param joinForm
   */
  $scope.attemptSubmission = function(joinForm){
    if(joinForm.$valid){
      selectVerificationMethod();
    } else {
      $scope.submitted = true;
    }
  };

  /**
   * @function formatPhone
   */
  $scope.formatPhone = function(){
    var phone = $scope.formData.phone;
    if (phone) {
      phone = phone.replace(/\D/g,'');
      if (phone.length > 10) {
        $scope.disableText = true;
        $scope.hidePhoneVerification = true;
        phone = companyPhoneNumber; // ignore numbers with country code and use ours
      } else {
        $scope.disableText = false;
        $scope.hidePhoneVerification = false;
      }
    }
    formattedPhone = phone;
  };

  /**
   * @function redeemCode
   */
  vm.redeemCode = function(){
    if($scope.attemptToRedeemCode) {
      return;
    }

    $scope.parent.overlayLoading = true;
    $scope.attemptToRedeemCode = true;
    var formData = $scope.formData;

    var request = {
      Email: $scope.formData.email,
      Phone: $scope.formData.phone,
      RedeemCode: formData.RedeemCode,
      Pin: formData.Pin,
      FirstName: formData.firstName,
      LastName: formData.lastName,
      Username: $scope.formData.email,
      Password: formData.password,
      CollectVirtual: "true"
    };

    $http({
      method: 'POST',
      url: baseURI + 'gift-card/redeem',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function (resp){
      var data = resp.data;

      $scope.attemptToRedeemCode = false;
      $scope.parent.overlayLoading = false;
      data.email = request.Email;

      if($scope.formData.textAlerts && !$scope.disableText){
        // set txt alerts for primary
        // if sub, set the subcard username
        data.textAlerts = {
          phoneNumber: $scope.formData.phone,
          subcard: null
        };
      } else {
        data.textAlerts = false;
      }
      if(typeof data.Data.OAuthData === "undefined" || data.Data.OAuthData === null) {
        $scope.parent.overlayLoading = false;
        var message = "We found an existing account for you and have applied these funds to that account. Please log in to your existing account to see these funds.";
        goToSuccessPage(message);
      } else {
        giftAuthService.handleAuth(data, $scope.formData.VerificationCode, $stateParams.redirect);
        trustPilotService.sendTpInvitation(request.Email, request.FirstName, 'redeemVirtual');
      }
    }).catch(function(error, status){
      $scope.attemptToRedeemCode = false;
      $scope.parent.overlayLoading = false;
      $scope.alertError.show = true;
      $scope.alertError.brandLogin = false;
      switch(error.data.ErrorCode){
        case 31:
          $scope.alertError.show = false;
          var message = "We found an existing account for you and have applied these funds to that account. Please log in to your existing account to see these funds.";
          goToSuccessPage(message);
          break;
        case 41:
          $scope.alertError.brandLogin = true;
          var domain = $scope.brand.programUrl.substring($scope.brand.programUrl.indexOf('//') + 2).split("/");
          $scope.alertError.loginLink = "https://app." + domain[0] + "/app/#/" + $scope.brand.name + "/login";
          $scope.alertError.message = "The provided redeem code has already been redeemed. If you went through this process previously, please log in with the email and password you provided during the collection process: ";
          break;
        case 42:
          $scope.alertError.message = "Sorry, the provided redeem code has expired. If you believe you've received this message in error, please contact the sender.";
          break;
        case 43:
          $scope.alertError.message = "Sorry, the provided redeem code seems to be invalid. If you believe you've received this message in error, please contact the code issuer.";
          break;
        case 120:
          $scope.alertError.message = "Sorry, your redeem code could not be collected. For verification and security purposes, please enter the same phone number or email address your redeem code was sent to when filling out this form.";
          break;
        default:
          $scope.alertError.message = 'Oops, we are unable to register your card at this time.';
          break;
      }
    });
  };

  // Prompt for verification method
  /**
   * @function selectVerificationMethod
   */
  var selectVerificationMethod = function() {


    $scope.verificationMethodChange = function(method) {
      $scope.formData.verificationMethod = method;
      $scope.verificationMethodIsPhone = $scope.formData.verificationMethod === 'phone';
      $scope.verificationMethodIsEmail = $scope.formData.verificationMethod === 'email';
    };

    // Default value
    $scope.verificationMethodChange($scope.formData.deliveryMethod);


    // Create the verification code
    createVerificationCode();


    /**
     * Open the verifyContact modal
     * @link /app/partials/verifyContact.html
     * @type {boolean}
     */
    $scope.showValidateEmail = true;
  };

  /**
   * @function submitSelectVerificationMethod
   */
  $scope.submitSelectVerificationMethod = function() {
    $scope.showSelectVerificationMethod = false;
    createVerificationCode();
  };

  /**
   * Function to request for a validation code
   * @function createVerificationCode
   */
  var createVerificationCode = function(){
    $scope.loading = true;


    var reqData = {
      VerificationType: $scope.formData.verificationMethod,
      Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : $scope.formData.email,
      _key: $scope.brand.api_key
    };

    $http({
      url: baseURI + 'member/verification',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function (resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        // Open the modal
        $scope.showValidateEmail = true;
        startCountDown();
      } else {
        $scope.alertError.show = true;
        $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
      }
    }).catch(function(error){
      $scope.loading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
    });
  };

  // User is manually submitting code
  /**
   * @function submitCode
   */
  $scope.submitCode = function(){

    if(!$scope.formData.VerificationCode){
      $scope.attemptedVerify = true;
      $scope.invalidVerify = false;
    } else {
      $scope.loading = true;
      $scope.attemptedVerify = false;
      var verifiedReq = {
        VerificationType: $scope.formData.verificationMethod,
        Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : $scope.formData.email,
        VerificationCode: $scope.formData.VerificationCode
      };

      $http({
        url: baseURI + 'member/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        $scope.invalidVerify = !data.Success;
        if(data.Success){
          $scope.stopTimeout();
          successVerfication();
        }
      }).catch(function(error){
        $scope.invalidVerify = true;
        $scope.loading = false;
      });
    }
  };

  // User clicks on resend email link
  /**
   * @function reSend
   */
  $scope.reSend = function(){
    $scope.stopTimeout();
    $scope.loadingEmailVerification = true;
    createVerificationCode();
  };

  /**
   * Function to close the pop-up modal window
   * @function close
   */
  $scope.close = function(){
    if ($scope.showValidateEmail) {
      $scope.showValidateEmail = false;
    }
    else {
      $scope.stopTimeout();
      $scope.showValidateEmail = false;
    }
  };

  /**
   * User has successfully completed email verification
   * @function successVerification
   */
  var successVerfication = function(){
    $scope.$parent.verifiedEmail = true;
    $scope.loadingEmailVerification = true;
    $scope.showValidateEmail = false;

    $state.go('root.redeem.virtual.esignDisclosure');
  };

  /**
   * @function startCountDown
   */
  var startCountDown = function() {
    $scope.counter = 1200;

    $scope.onTimeout = function(){
      $scope.counter--;
      if($scope.counter > 1){
        myTimeout = $timeout($scope.onTimeout, 1000);
      } else {
        $scope.stopTimeout();
        $scope.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout($scope.onTimeout, 1000);

    // Cancel the promise
    $scope.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };
  };

  //Agreements

  vm.section1 = true;
  vm.section2 = false;
  vm.section3 = false;
  vm.section4 = false;

  vm.eSignAgreed = false;
  vm.disclosureAgreed = false;
  vm.privacyAgreed = false;
  vm.feesScheduleAgreed = false;

  $scope.eSignErrorMessage = 'Please check this box if you agree to the E-sign disclosure. You must agree to the E-sign disclosure to continue.';
  $scope.cardholderAgreementErrorMessage = 'Please check this box if you agree to the Cardholder Agreement. You must agree to the Cardholder Agreement to continue.';
  $scope.privacyPolicyErrorMessage = 'Please check this box if you agree to the Sunrise Banks Privacy Policy. You must agree to the Sunrise Banks Privacy Policy to continue.';

  var urlRoot = window.location.href.split('#')[0];
  var currentBrand = $scope.brand.name;
  var brand = brandService.getBrand($stateParams.brand);

  function resolvePdfUrl(basePath, fallbackPath, callback) {
    $http.head(basePath).then(
        function () {
          callback(basePath);
        },
        function () {
          callback(fallbackPath);
        }
    );
  }

  function initializePdfSources() {
    var defaultAgreement = 'https://akimbocard.wpenginepowered.com/wp-content/uploads/2021/07/Cardholder-Agreement_GPR_Akimbo_FICENTIVEAKIMBOMCGPRTC_0721-8.pdf';
    var currentBrandAgreement = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/cardholder-agreement.pdf';

    resolvePdfUrl(
        currentBrandAgreement,
        defaultAgreement,
        function (resolvedUrl) {
          vm.pdfGDSrcAgreement = resolvedUrl + '#toolbar=0';
          vm.pdfGDSrcAgreementDownload = resolvedUrl;
        }
    );

    var defaultFeeSchedule = urlRoot.replace('?', '') + 'assets/pdf/akimbo/fee-schedule.pdf';
    var currentBrandFeeSchedule = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf';

    resolvePdfUrl(
        currentBrandFeeSchedule,
        defaultFeeSchedule,
        function (resolvedUrl) {
          vm.feesSchedule = resolvedUrl + '#toolbar=0';
          vm.feesScheduleDownload = resolvedUrl;
        }
    );

    vm.pdfGDSrcDisclosure = brand.programLegal.disclosure + '#toolbar=0';
    vm.pdfGDSrcDisclosureDownload = brand.programLegal.disclosure;

    vm.pdfGDSrcPrivacy = 'https://akimbocard.wpenginepowered.com/wp-content/uploads/2020/03/Sunrise-Banks-Privacy-Notice-Safe-Harbor.pdf#toolbar=0';
    vm.pdfGDSrcPrivacyDownload = 'https://akimbocard.wpenginepowered.com/wp-content/uploads/2020/03/Sunrise-Banks-Privacy-Notice-Safe-Harbor.pdf';

    vm.feesSchedule = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf#toolbar=0';
    vm.feesScheduleDownload = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf';
  }

  vm.trustSrc = function (src) {
    return $sce.trustAsResourceUrl(src);
  };

  vm.Finish = function (nextStep) {
    $state.go(nextStep, { joinType: $scope.joinType });
  };

  vm.downloadFile = function (url, filename) {
    var link = $window.document.createElement('a');
    link.href = url;
    link.download = filename;
    link.target = '_blank';
    $window.document.body.appendChild(link);
    link.click();
    $window.document.body.removeChild(link);
  };

  function initializeController() {
    initializePdfSources();
  }

  initializeController();
}]);
